import { CoreEnv, CoreRequest, CoreUser } from '@eventbrite/context-gen';
import { VenueValues } from '@eventbrite/create-common';
import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Organization } from '../screens/Form';

export type EventDTO = {
    event: {
        id: string;
        is_free: boolean;
        online_event: boolean;
        venue_id?: string;
    };
    publishable: {
        errors: string[];
        field_errors: {
            [key: string]: string[];
        };
        valid: boolean;
    };
};

export interface AutoCreateCoreEnv extends CoreEnv {
    defaultCurrency: string;
}

export interface CoreUserWithActiveOrganization extends CoreUser {
    activeOrganization: Organization | null;
}

export interface AppProps {
    creator?: {
        hasPublish: boolean;
        hasPaidPublish: boolean;
    };
    organizer?: {
        id: string;
    };
    env?: AutoCreateCoreEnv;
    featureFlags?: {
        [featureFlag: string]: boolean;
        launchNewBillingSettings: boolean;
    };
    request?: CoreRequest;
    user?: CoreUserWithActiveOrganization;
    organizationId?: string;
    expectedAttendees?: number;
    event?: EventDTO['event'];
    testPath?: string;
    isOrganizationVerified?: boolean;
}

export enum LocationType {
    Venue = 'venue',
    Online = 'online',
    ToBeAnnounced = 'to_be_announced',
}

interface RouteParams {
    id: string;
}

export type AppRouteProps = RouteComponentProps<RouteParams>;

export type AppWithRouteProps = AppProps & AppRouteProps;

export interface RouteWithPropsProps {
    component: FC<AppWithRouteProps>;
    componentProps: AppProps;
    path: string;
}

export type EventDateTime = {
    local: string;
    timezone: string;
    utc: string;
};

export type TransientAutoCreatedEvent = {
    id?: string;
    end: Omit<EventDateTime, 'local'>;
    name: {
        html: string;
    };
    start: Omit<EventDateTime, 'local'>;
    summary: string;
    description: string;
    image_url: string;
    locale: string;
    location_type: LocationType;
    venue?: VenueValues;
};

export type TransientAutoCreatedEventResponse = {
    event: TransientAutoCreatedEvent;
};

export interface IAuthProps {
    request?: CoreRequest;
    gaSettings?: {
        userPartnerId?: string | null;
        appName?: string;
        activeScopeUserId?: string | null;
        appVersion?: string | null;
        guestPartnerId?: string;
        isActive?: boolean;
        correlationId?: string;
    };
    recaptcha2PublicKey?: string;
    recaptcha3PublicKey?: string;
    featureFlags?: {
        [featureFlag: string]: boolean;
    };
    socialSSOSettings?: {
        twoStepsSignup: boolean;
        google: {
            scope: string;
            redirectURI: string;
            clientId: string;
        };
        facebook: {
            scope: string;
            version: string;
            appId: string;
        };
        apple: {
            scope: string;
            redirectURI: string;
            clientId: string;
        };
    };
    fp?: boolean;
}
